const lineHeights = {
  "9xl": "7rem", // 112px
  "8xl": "6rem", // 96px
  "7xl": "4.75rem", // 76px
  "6xl": "4rem", // 64px
  "5xl": "3.25rem", // 52px
  "4xl": "2.5rem", // 40px
  "3xl": "2.125rem", // 34px
  "2xl": "1.75rem", // 28px
  xl: "1.5rem", // 24px
  lg: "1.375rem", // 22px
  md: "1.375rem", // 22px
  sm: "1.125rem", // 18px
  xs: "1rem", // 16px
}

const fonts = {
  heading: "Segment, sans-serif",
  body: "Segment, sans-serif",
}

export default {
  fonts,
  lineHeights,
}
